import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { SecondaryButton } from '@workspace/ui/components/dsm/secondary-button'
import { useState } from 'react'
import { ConnectDialog } from './connect-dialog.js'

export function BottomCta({
  startupName,
  onConnect,
  connectPending,
  onRequestDiligence,
  onFollowCompany,
}: {
  startupName: string
  onConnect?: (message?: string) => void
  connectPending?: boolean
  onRequestDiligence?: () => void
  /**
   * Share-link only. When present it REPLACES "Get custom diligence", which
   * sends an anonymous investor to an "Investor access only" wall — a CTA that
   * fails the founder-safe test on the founder's own page. The logged-in
   * deal-flow view keeps the diligence upsell, because there the visitor
   * already has an account.
   */
  onFollowCompany?: () => void
}) {
  const [connectOpen, setConnectOpen] = useState(false)

  return (
    <div className="border-t border-border px-4 py-7 lg:px-8 lg:py-9">
      {/* A quiet document footer, not a banner. As a full-bleed orange block
          this was the loudest object on the page by an order of magnitude — it
          out-shouted the company name, the summary and the scores combined, and
          on a page a founder sends to investors the platform should not be the
          thing shouting. Orange now appears once here, on the founder's own
          action. */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-base font-semibold text-white">Interested in {startupName}?</h2>
          <p className="mt-1 text-sm text-muted-foreground">Reach the founder directly.</p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row sm:items-center">
          {/* Connecting with the founder leads. The diligence upsell is
              SeedForge's product being offered to a visitor the founder
              brought, so it does not get to be the primary action here. */}
          {/* Rendered only when it can actually do something. The previous
              form was `onClick={() => onConnect && setConnectOpen(true)}`, which
              silently no-ops without a handler — a button that looks live and
              answers nothing, and the reason "Connect with founder" was reported
              as producing no visible response at all. */}
          {onConnect && (
            <CtaButton onClick={() => setConnectOpen(true)}>Connect with founder</CtaButton>
          )}
          {onFollowCompany ? (
            <SecondaryButton onClick={onFollowCompany}>Follow this company</SecondaryButton>
          ) : (
            onRequestDiligence && (
              <SecondaryButton onClick={onRequestDiligence}>Get custom diligence</SecondaryButton>
            )
          )}
        </div>
      </div>
      {onConnect && (
        <ConnectDialog
          startupName={startupName}
          open={connectOpen}
          onOpenChange={setConnectOpen}
          onConnect={onConnect}
          isPending={connectPending}
        />
      )}
    </div>
  )
}
